<pre class="m-0 overflow-hidden"><code [highlight]="stringifiedShadow" language="json"></code></pre>
